import React from 'react';

import PropTypes from 'prop-types';
import Form from 'react-bootstrap/Form';

const CheckboxGroup = ({
    children,
    dataOptiontype,
    checked,
    id,
    value,
    onChange,
}) => (
    <Form.Check
        type="checkbox"
        data-optiontype={dataOptiontype}
        id={id}
        name={value}
        value={value}
        checked={checked}
        onChange={onChange}
        label={children}
    />
);

CheckboxGroup.propTypes = {
    children: PropTypes.node.isRequired,
    dataOptiontype: PropTypes.string.isRequired,
    checked: PropTypes.bool.isRequired,
    id: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
};

export default CheckboxGroup;
